import { RootState } from '..';

export const getPickup = (state: RootState) => state.pickup;
